import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { normalize } from 'lib/utils';
import useProductBasicDetails from 'data-hooks/useProductBasicDetails';
const useProductDimensions = (productId, slug, t0) => {
  const $ = _c(9);
  const skip = t0 === undefined ? false : t0;
  const [dimensions, setDimensions] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== skip) {
    t2 = {
      skip
    };
    $[1] = skip;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    data
  } = useProductBasicDetails(productId, slug, t1, t2);
  let t3;
  if ($[3] !== data) {
    t3 = data ?? {};
    $[3] = data;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    attributes: attributesArray
  } = t3;
  let t4;
  let t5;
  if ($[5] !== attributesArray || $[6] !== skip) {
    t4 = () => {
      if (skip) {
        return;
      }
      const attributes = normalize({
        data: attributesArray,
        key: "code"
      }).data;
      const dimensionsArray = [];
      if (attributes?.width?.value) {
        dimensionsArray.push(`${attributes.width.value}"w`);
      }
      if (attributes?.depth?.value) {
        dimensionsArray.push(` x ${attributes.depth.value}"d`);
      }
      if (attributes?.height?.value) {
        dimensionsArray.push(` x ${attributes.height.value}"h`);
      }
      const updatedDimensions = dimensionsArray.join("  ");
      setDimensions(updatedDimensions);
    };
    t5 = [attributesArray, skip];
    $[5] = attributesArray;
    $[6] = skip;
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  return dimensions;
};
export default useProductDimensions;